import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Drawer, DrawerHeader } from "../components/drawer/drawer";
import { Box, CssBaseline } from "@mui/material";
import { AppBar } from "../components/appbar/appbar";
import { Main } from "../components/main/main";
import { AuthContext } from "../../contexts";
import { useWidth } from "../../libs/hooks";
import { useTheme } from '@mui/material/styles';
import { useRouterStore } from "../../libs/stores";

export const Layout = () => {
  const theme = useTheme();
  const location = useLocation();
  const width = useWidth();
  const [open, setOpen] = React.useState(false);
  const [numproCrono, setNumproCrono] = React.useState("");
  const [headerWord, setHeaderWord] = React.useState("...");
  const clientId = useRouterStore((state) => state.clientId);

  const tokens = localStorage.getItem(process.env.REACT_APP_TOKEN!);
  const existingTokens = tokens ? JSON.parse(tokens) : null;

  const [authTokens, setAuthTokens] = React.useState(existingTokens);

  const setTokens = (data:any) => {
    localStorage.setItem(process.env.REACT_APP_TOKEN!, JSON.stringify(data));
    setAuthTokens(data);
  };

  if (!tokens) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AuthContext.Provider
        value={{
          authTokens,
          headerWord,
          numproCrono,
          setAuthTokens: setTokens,
          setHeaderWord,
          setNumproCrono,
        }}
      >
        <AppBar
          open={open}
          handleDrawerOpen={handleDrawerOpen}
          authTokens={existingTokens}
          clientId={clientId}
        />
        <Drawer open={open} handleClose={handleDrawerClose} />
        <Main open={open} width={width} theme={theme}>
          <DrawerHeader />
          <Outlet />
        </Main>
      </AuthContext.Provider>
    </Box>
  );
};
